import Raven from 'raven-js';
import { FETCH_CONTACTS_QUERY } from '../__generated__/chirp/com/hubspot/och/integration/rpc/OCHIntegrationRpc.dfc.new';
// This function can be called in a card registry in order to fire a request
// before your JS has loaded and evaluated.
export const dataResolver = ({
  graphqlClient: __graphqlClient,
  dfcClient
}, {
  cardData: __cardData,
  additionalLocationData: {
    objectId,
    objectTypeId
  }
}) => {
  if (!objectId || !objectTypeId) {
    return Promise.reject(new Error('Missing objectId or objectTypeId'));
  }
  return dfcClient.query({
    query: FETCH_CONTACTS_QUERY,
    variables: {
      objectRefTypeId: objectTypeId,
      objectRefId: objectId.toString()
    }
  }).then(result => ({
    contactsData: result.data.result.responseData
  })).catch(error => {
    Raven.captureException(error, {
      tags: {
        component: 'dataResolver'
      },
      extra: {
        message: 'Failed to fetch contacts'
      }
    });
    return error;
  });
};